import { Button, DatePicker, Form, Input, Modal, Select } from 'antd'
import React, { useState } from 'react'
import { updateData } from '../../../../resources'
import { PlusOutlined } from '@ant-design/icons'

export default function HojaRegistroMiniModal({ protocolo, boxId, fetchBoxes }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [form] = Form.useForm()

  function transformToFechas(data) {
    console.log('Formatting')
    // Parse the ISO date string
    const date = new Date(data.fecha);

    // Format date as DD/MM/YY
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const formattedDate = `${day}/${month}/${year}`;
    // Return object with formatted date as key
    return {
      [formattedDate]: {
        pulsos: data.pulsos,
        nivel: data.nivel
      }
    };
  }

  const onFinish = (values) => {
    const date = new Date(values.fecha);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const formattedDate = `${day}/${month}/${year}`;


    console.log('Form values:', values)
    // Aquí puedes manejar el envío del formulario, como hacer una solicitud a la API
    // const formattedData = transformToFechas(values);
    // console.log('Formatted Data:', formattedData);
    // const newFechas = { ...protocolo.fechas, ...formattedData };
    // protocolo.fechas = newFechas;
    // console.log('Nuevo protocolo:', protocolo);


    const body = {
      fecha: formattedDate,
      pulsos: values.pulsos,
      nivel: values.nivel
    }

    const url = `emt-box/update-protocolo-fecha/${boxId}/${protocolo.key}/`;
    console.log('Updating at url ', url)
    console.log('With data ' , body)

    updateData(url, body).then((res) => {
      console.log('Protocolo actualizado:', res);
    }).catch((error) => {
      console.error('Error al actualizar el protocolo:', error);
    });

    if (fetchBoxes) {
      fetchBoxes();
    }

    setIsModalOpen(false);
    form.resetFields();

  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }


  // ... rest of your code

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center'  }}>
      <Button type="primary" ghost shape='round' onClick={() => setIsModalOpen(true)} icon={<PlusOutlined />} />
      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null}>

        {/* {
          protocolo && JSON.stringify(protocolo)
        } */}
        <Form name='emt-box-mini' form={form} layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed}>
          <p>Agregar</p>
          <Form.Item label="Fecha" name="fecha">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="Pulsos" name="pulsos">
            <Input placeholder='Pulsos' />
          </Form.Item>
          <Form.Item label="Nivel" name="nivel">
            <Select placeholder="Selecciona nivel">
              <Select.Option value="Nivel 1">1</Select.Option>
              <Select.Option value="Nivel 2">2</Select.Option>
              <Select.Option value="Nivel 3">3</Select.Option>
              <Select.Option value="Nivel 4">4</Select.Option>
              <Select.Option value="Nivel 5">5</Select.Option>
            </Select>
          </Form.Item>
          <Button type='primary' htmlType="submit" form='emt-box-mini'>Guardar</Button>
        </Form>

      </Modal>
    </div>
  )
}
